// extracted by mini-css-extract-plugin
export default {"CircleBadge":"MarketplaceListings-module__CircleBadge--M7rH0"};